module.exports = __webpack_public_path__ + "media/app/assets/classes/hunter-79d52bc619759d9ed9df20b9b8d90798.jpg";